/**
 * YouTube reports durations as ISO 8601 (`PT4M13S`), which nothing else in the
 * app wants to think about.
 */
const ISO_DURATION = /^P(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?$/;
/** Returns milliseconds, or 0 when the input is missing or unparseable. */
export function parseIso8601Duration(value) {
    if (!value)
        return 0;
    const match = ISO_DURATION.exec(value.trim());
    if (!match)
        return 0;
    const [, days, hours, minutes, seconds] = match;
    // A bare "P" or "PT" parses structurally but means nothing.
    if (!days && !hours && !minutes && !seconds)
        return 0;
    return Math.round((Number.parseInt(days ?? '0', 10) * 86_400 +
        Number.parseInt(hours ?? '0', 10) * 3_600 +
        Number.parseInt(minutes ?? '0', 10) * 60 +
        Number.parseFloat(seconds ?? '0')) *
        1000);
}
/** `3:42`, or `1:02:03` past an hour. Used everywhere a length is shown. */
export function formatDuration(ms) {
    if (!Number.isFinite(ms) || ms <= 0)
        return '—';
    const total = Math.round(ms / 1000);
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    const pad = (n) => String(n).padStart(2, '0');
    return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
}
//# sourceMappingURL=duration.js.map